// extracted by mini-css-extract-plugin
module.exports = {"Label":"QuestInfo_Label__15gPN","Value":"QuestInfo_Value__2iW5l","ImagesWrapper":"QuestInfo_ImagesWrapper__3XiFz"};